// Movement intent builders (server-authoritative movement, P5-cast-move). Each
// returns a `{ domain:'movement', kind, ... }` object the server's match:intent
// handler routes into movementService. The server VALIDATES the destination
// against the unit's authoritative reach (step/region/survival/wall) and commits
// SET_POSITION (+ subsurface + auto-tap) in one diff. The cosmetic glide stays
// client-side. Keep payload shapes in lockstep with
// valkenhall-server/src/match/movementService.js.

// Move a unit to {toCol,toRow} landing in `toRegion` (surface / underground /
// underwater / void). `autoTap` taps the unit on arrival ("Move and Attack");
// pass false for a no-tap move (Charge etc.). The drop's world {x,z} rides
// every non-site move and persists as card.pos, so a free-placing client
// (snap-to-grid off, or a manual session) renders the card exactly where it
// was dropped. Snapping clients derive the pose from cell + stackSeq instead.
export function moveIntent(cardId, { toCol, toRow, toRegion = 'surface', autoTap = true, x, z } = {}) {
  return {
    domain: 'movement', kind: 'move', cardId, toCol, toRow, toRegion, autoTap,
    ...(Number.isFinite(x) && Number.isFinite(z) ? { x, z } : {}),
  };
}
